import { Container, Grid, Typography, Button } from '@mui/material';
import "./index.css"
import Form from './Components/Form';
import { useEffect, useState } from 'react';
import { authentication } from './Services/Authentication';
import swal from 'sweetalert';
import { getImageUser } from './Services/Image';
import { getFields } from './Services/Fields';
import { validateData } from './Utils';
import { saveInfo } from './Services/SaveForm';
import Loading from './Components/Loading';

function App() {
  //Almacenamos los campos del formulario
  const [field, setFields] = useState({})

  //Almacenamos el logo de la empresa
  const [imageCompany, setImageCompany] = useState("")

  //Campos obligatorios
  const [error, setError] = useState({})

  //Campos obligatorios
  const [openLoading, setOpenLoading] = useState(false)

  //Campos obligatorios
  const [dependencyFilter, setDependencyFilter] = useState({})

  //Campos obligatorios
  const [valueField, setValueField] = useState({})
  

  //Hacemos la autenticacion del usuario
  async function send(key) {
    if (key) setOpenLoading(true)
    await authentication().then(async response => {
      localStorage.setItem("user", response.data)
      if (key) getDataClient();
      setOpenLoading(false)

    }).catch(error => {
      if (key) {
        localStorage.removeItem("user")
        swal("Problemas en la autenticación", "Hemos tenido problemas al intentar autenticarte, por favor comunicate con una persona de soporte", "error");
      }
      setOpenLoading(false)
    })
  }

 

  //Cada vez que el usuario entre al apiclativo lanzamos la autenticacion 1000
  useEffect(() => {
  
    localStorage.removeItem("user")
    //Obtenemos el token cada 8 minutos para que no vaya a expirar
    setInterval(() => {
      send(false)
    }, 200000);

    //Obtenemos la informacion primaria 
    send(true)
  }, [])

  //Obtenemos la informacion del cliente
  async function getDataClient() {
    setOpenLoading(true)
    await getImageUser().then(response => {
      setImageCompany(response.data.img)
    }).catch(error => {
      setOpenLoading(false)
    })

    await getFields().then(response => {
      setFields(response.data)
    }).catch(error => {
      setOpenLoading(false)
      swal("Error", "Hemos tenido problemas al obtener los campos del formulario, por favor comunicate con una persona de soporte", "error");
    })
    setOpenLoading(false)

  }

  const handleChangeMain = async (value, fields) => {
   
    let dataFull = {...valueField, [fields]: value}
    //insertValue(field, fields, value);
    let nullData = {}
    if (fields === "id_tercero_cliente" || fields === "id_sucursal") {
      let filterItem = {}
      if(fields === "id_tercero_cliente"){
        filterItem = { "id_sucursal": [{ "value": value, "key": "id_tercero"}]}
        nullData = {...nullData, "id_sucursal":null,"id_equipo":null }
      }else if(fields === "id_sucursal"){
        nullData = {...nullData, "id_equipo":null }
          filterItem = { "id_equipo": [
            { "value": valueField.id_tercero_cliente, "key": "id_tercero"},
            { "value": value, "key": "id_sucursal"},
          ]
        }
      }
      setDependencyFilter({ ...dependencyFilter, ...filterItem })
    }
    setValueField({...dataFull, ...nullData})
  }


  const saveData = async () => {
    const validateInfo = await validateData(field, setError, valueField)
    if (validateInfo) {
      setOpenLoading(true)     
      await saveInfo(validateInfo).then(response => {
        setValueField({})
        swal("Guardado exitoso", "", "success");
        setOpenLoading(false)
      }).catch(error => {
        swal("Hemos tenido problemas con el guardado, intenta de nuevo", "", "error");
      })
    }
  }
  return (

    <Container className={"mainBody"} maxWidth="md">
      <Loading open={openLoading} />
      <Grid item xs={12} >
        <div className={"logoMain"} style={{ backgroundImage: "url(" + imageCompany + ")" }}>
        </div>
        <Typography
          variant="h2"
          component="h2"
          className={"colorMainBlue textCenter"}
        >
          SOLICITUD DE SERVICIOS TÉCNICOS
        </Typography>

        <Typography
          variant="h5"
          component="h5"
          className={"textCenter"}
        >
          Por favor ingrese la información correspondiente al servicio técnico que requiere:
        </Typography>
      </Grid>

      <Form field={field}
        handleChangeMain={handleChangeMain}
        error={error}
        dependencyFilter={dependencyFilter}
        valueField={valueField}
      />

      <Grid item xs={12}>
        <Typography
          variant="h6"
          component="h6"
          className={"marginTop20"}>
          Actualizaremos la información almacenada, usada y tratada de conformidad con las Políticas de Privacidad de la empresa
        </Typography>
        {Object.keys(field)?.length > 0 &&

          <Button className="pushable" onClick={saveData}>
            <span className="front">
              ENVIAR
            </span>
          </Button>



        }
      </Grid>

      <Grid container rowSpacing={1} className={"footer"}>
        <Grid item xs={12} sm={4} >
          <span className={"colorWhite"}>
            Desarrollado por Idae Soluciones
          </span>
        </Grid>

        <Grid item xs={12} sm={8}>
          <ul>
            <li><a href="https://www.idaesoluciones.com/">Visítanos</a></li>
          </ul>
        </Grid>
      </Grid>
    </Container>
  );
}

export default App;
